const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#151515",
    flexDirection: "column",
    boxShadow: "5px 5px 30px rgba(0, 0, 0, 0.2)",
    cursor: "none !important",
  },
  h1: {
    cursor: "none !important",
    fontFamily: "Montserrat",
    fontWeight: "600",
    fontSize: "28px",
    textAlign: "center",
    lineHeight: "33.6px",
    letterSpacing: "0.01em",
    color: "white",
    marginTop: "92px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      marginTop: "40px",
      fontSize: "20px",
    },
  },
  btn: {
   display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "none !important",
    borderRadius: "0",
    border: "2px solid #FFFFFF",
    padding: "10px 20px",
    color: "#FFFFFF",
    fontFamily: "Montserrat",
    letterSpacing: "0.01em",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "17px",
    margin: "10px",
    textDecoration:"none",
    textTransform: "none",
    height: "48px",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#FFFFFF",
      color: "black",
      border: "2px solid #FFFFFF",
    },
  },
  btnWrap: {
    cursor: "none !important",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "100px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      flexDirection: "column",
      marginBottom: "40px",
    },
  },
});

export default styles;
